import React from 'react';

const PrivacyPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="px-4 py-8">
        <div className="max-w-4xl mx-auto bg-white border border-gray-200 rounded-2xl p-6 md:p-8">
          <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-8 text-center">개인정보처리방침</h1>
          
          <div className="mb-8 text-gray-700" onClick={() => {
            throw new Error("일부러 발생시킨 에러2입니다.");
          }}>

            <p className="mb-4">
              본 개인정보처리방침은 웹서비스 엔빵 애플리케이션과 모바일 기기용 <strong>엔빵 애플리케이션(이하 "애플리케이션")</strong>에 적용되며, 
              <strong>부싯돌(이하 "서비스 제공자")</strong>가 무료 서비스로 제공합니다. 본 서비스는 "있는 그대로(AS IS)" 제공됩니다.
            </p>
          </div>
          <div className="mb-4">

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">1. 정보의 수집 및 이용</h3>
            <p className="mb-4 text-gray-700">
              애플리케이션은 다운로드 및 사용 시 다음과 같은 정보를 수집할 수 있습니다.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
              <li>기기의 인터넷 프로토콜(IP) 주소</li>
              <li>방문한 애플리케이션 내 페이지, 방문 일시 및 체류 시간</li>
              <li>애플리케이션 전체 이용 시간</li>
              <li>모바일 기기의 운영체제(OS)</li>
            </ul>
            <p className="mb-4 text-gray-700">
              애플리케이션은 사용자의 정확한 위치정보를 수집하지 않습니다.  
              서비스 제공자는 이용자가 제공한 정보를 통해 중요 안내, 법적 고지, 마케팅 정보를 제공할 수 있습니다.  
              또한 원활한 서비스 이용을 위해 이름, 전화번호 등 개인 식별이 가능한 정보를 요청할 수 있으며, 
              해당 정보는 본 방침에 따라 보관·이용됩니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">2. 제3자 접근</h3>
            <p className="mb-4 text-gray-700">
              서비스 제공자는 애플리케이션 및 서비스 개선을 위해 집계·익명화된 데이터를 외부 서비스에 전송할 수 있습니다.  
              또한, 아래의 제3자 서비스가 사용되며 각 서비스의 개인정보처리방침이 적용됩니다.
            </p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700 mb-4">
              <li>Google Play Services</li>
              <li>Expo</li>
              <li>Sentry</li>
            </ul>
            <p className="mb-4 text-gray-700">
              서비스 제공자는 법령 준수, 권리 보호, 안전 확보, 사기 조사, 정부 요청 대응 등의 사유로 
              사용자 제공 정보 및 자동 수집 정보를 공개할 수 있습니다.  
              또한 신뢰할 수 있는 서비스 제공업체와 업무를 위탁할 수 있으며, 이 경우 해당 업체는 독립적으로 정보를 사용할 수 없고 
              본 방침을 준수해야 합니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">3. 수집 거부 권리</h3>
            <p className="mb-4 text-gray-700">
              사용자는 애플리케이션을 삭제(언인스톨)함으로써 정보 수집을 중단할 수 있습니다.  
              이는 기기 내 기본 삭제 절차 또는 앱 마켓을 통해 가능합니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">4. 데이터 보관 정책</h3>
            <p className="mb-4 text-gray-700">
              서비스 제공자는 사용자가 애플리케이션을 이용하는 동안 및 합리적인 기간 동안 사용자 제공 데이터를 보관합니다.  
              데이터 삭제를 원할 경우 <strong>vinoankr@gmail.com</strong>으로 연락하면 합리적인 기간 내에 조치합니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">5. 보안</h3>
            <p className="mb-4 text-gray-700">
              서비스 제공자는 개인정보의 기밀성을 보호하기 위해 물리적, 전자적, 절차적 보안조치를 마련하고 있습니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">6. 방침 변경</h3>
            <p className="mb-4 text-gray-700">
              본 개인정보처리방침은 필요 시 개정될 수 있으며, 변경 사항은 본 페이지에 업데이트됩니다.  
              본 방침은 2025년 9월 1일부터 적용됩니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">7. 동의</h3>
            <p className="mb-4 text-gray-700">
              애플리케이션을 이용함으로써 사용자는 본 개인정보처리방침(개정된 경우 포함)에 동의하는 것으로 간주됩니다.
            </p>

            <h3 className="text-lg font-semibold text-gray-800 mt-6 mb-2">8. 문의</h3>
            <p className="mb-4 text-gray-700">
              개인정보 처리와 관련하여 문의 사항이 있는 경우 <strong>vinoankr@gmail.com</strong>으로 연락 주시기 바랍니다.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPage;
